import React from 'react';
import { SlideProps } from './slideTypes';
import { SLIDE_COMPONENT_TEXT_SIZE } from './slideConstants';

export function DefaultSlide({ slide }: SlideProps) {
  const content = slide.data?.content || JSON.stringify(slide.data || {});
  
  return (
    <div className="flex flex-col gap-3 md:gap-4 w-full px-4 md:px-6 py-6 md:py-8 items-start justify-center text-left overflow-y-auto max-h-full">
      <span className="text-xs md:text-sm text-white/90 leading-relaxed text-left">
        {String(content)}
      </span>
    </div>
  );
}
